var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReference(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8491 17.5806C12.2528 17.5806 13.3907 16.4427 13.3907 15.0391C13.3907 13.6354 12.2528 12.4976 10.8491 12.4976C9.4455 12.4976 8.30762 13.6354 8.30762 15.0391C8.30762 16.4427 9.4455 17.5806 10.8491 17.5806Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2183 17.5806C22.6219 17.5806 23.7598 16.4427 23.7598 15.0391C23.7598 13.6354 22.6219 12.4976 21.2183 12.4976C19.8146 12.4976 18.6768 13.6354 18.6768 15.0391C18.6768 16.4427 19.8146 17.5806 21.2183 17.5806Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0334 5.90461C8.78258 5.90461 2.90461 11.7825 2.90461 19.0334C2.90461 26.2842 8.78258 32.1622 16.0334 32.1622C23.2843 32.1622 29.1622 26.2842 29.1622 19.0334C29.1622 11.7825 23.2843 5.90461 16.0334 5.90461ZM0 19.0334C0 10.1784 7.17843 3 16.0334 3C24.8884 3 32.0668 10.1784 32.0668 19.0334C32.0668 27.8884 24.8884 35.0668 16.0334 35.0668C7.17843 35.0668 0 27.8884 0 19.0334Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0339 28.0959C20.3036 28.0959 23.7601 24.6394 23.7601 20.3696H8.30762C8.30762 24.6394 11.7641 28.0959 16.0339 28.0959Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7441 31.6035C12.7441 22.6949 20.3099 15.4731 29.6426 15.4731C38.9754 15.4731 46.5411 22.6949 46.5411 31.6035C46.5411 40.5121 38.9754 47.7339 29.6426 47.7339C20.3099 47.7339 12.7441 40.5121 12.7441 31.6035Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6048 29.7643C25.2187 29.7643 26.527 28.456 26.527 26.8421C26.527 25.2282 25.2187 23.9199 23.6048 23.9199C21.9909 23.9199 20.6826 25.2282 20.6826 26.8421C20.6826 28.456 21.9909 29.7643 23.6048 29.7643Z",
    fill: "#0F20E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5267 29.7643C37.1405 29.7643 38.4488 28.456 38.4488 26.8421C38.4488 25.2282 37.1405 23.9199 35.5267 23.9199C33.9128 23.9199 32.6045 25.2282 32.6045 26.8421C32.6045 28.456 33.9128 29.7643 35.5267 29.7643Z",
    fill: "#0F20E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5656 16.3396C21.2288 16.3396 14.4705 23.0979 14.4705 31.4347C14.4705 39.7715 21.2288 46.5298 29.5656 46.5298C37.9024 46.5298 44.6607 39.7715 44.6607 31.4347C44.6607 23.0979 37.9024 16.3396 29.5656 16.3396ZM11.1309 31.4347C11.1309 21.2535 19.3844 13 29.5656 13C39.7469 13 48.0004 21.2535 48.0004 31.4347C48.0004 41.616 39.7469 49.8694 29.5656 49.8694C19.3844 49.8694 11.1309 41.616 11.1309 31.4347Z",
    fill: "#0F20E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.566 41.8546C34.4753 41.8546 38.4494 37.8804 38.4494 32.9712H20.6826C20.6826 37.8804 24.6568 41.8546 29.566 41.8546Z",
    fill: "#0F20E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0762 1V11.5954",
    stroke: "#0F20E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.15 6.30664H32",
    stroke: "#0F20E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReference);
export default __webpack_public_path__ + "static/media/reference.277a67db597f80007f7116dfbfa9ba3a.svg";
export { ForwardRef as ReactComponent };